<template>
    <client-page>
        <section class="section">
            <v-container>
                <template v-if="program._id">
                    <expo-program-view v-bind="{ program }" />
                </template>
                <v-fade-transition>
                    <v-overlay v-show="loading" :dark="false" color="white">
                        <v-progress-circular indeterminate size="100" width="5" color="primary" />
                    </v-overlay>
                </v-fade-transition>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import api from "@/api";
import { initExpoProgram } from "@/assets/variables/inits";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import ExpoProgramView from "@/components/client/expo/programs/expo-program-view.vue";

export default {
    components: {
        ClientPage,
        ExpoProgramView,
    },
    props: {
        _program: { type: String },
    },
    data: () => ({
        program: initExpoProgram(),

        loading: false,
    }),
    methods: {
        async init() {
            this.loading = true;
            try {
                const { program } = await api.v1.expo.programs.get({ _id: this._program });

                if (!program) {
                    alert("해당 프로그램을 찾을 수 없습니다.");
                    throw this.$router.replace("/");
                }

                this.program = initExpoProgram(program);
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
    watch: {
        _program() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style></style>
